import { InjectionToken } from '@angular/core';
import { SelectRowOptions } from './select-row.options';

export const EUROGARD_MATERIAL_TABLE_SYSTEM_SELECT_ROW_OPTIONS = new InjectionToken<SelectRowOptions>(
  'table-system/select-row/options');
